import { type RoleCode, USER_STATUSES, type UserStatus } from "@seagames/contracts";
import type { TFunction } from "i18next";

/**
 * Role / status copy lives in the `users` i18n namespace; these helpers resolve
 * it at call time so a language switch re-renders every badge. The chip itself
 * (colours) is `StatusChip` in components/users/ui.tsx — a colour is not a
 * translation.
 */
type UsersT = TFunction<["users", "common"]>;

export const roleLabel = (t: UsersT, code: RoleCode): string => t(`roles.${code}`);

/** Every status, as a lookup ("is this audit value a user status?"). */
export const USER_STATUS_SET: ReadonlySet<string> = new Set<string>(USER_STATUSES);

export const statusLabel = (t: UsersT, status: UserStatus): string => t(`status.${status}`);

export const statusHint = (t: UsersT, status: UserStatus): string => t(`statusHint.${status}`);
